module.exports = __webpack_public_path__ + "static/media/knowledge_center.f6f4de8e.svg";